export default {"src":"/_next/static/media/logo_fairprice_xtra.3e1ffc54.svg","height":40,"width":204,"blurWidth":0,"blurHeight":0};